import { styled } from "@mui/material/styles";
import {
    Grid,
    GridProps,
    InternalStandardProps,
    Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PaymentMethod, PaymentMethodRadio } from "./PaymentMethodRadio";
import { TransactionCompleteDialog } from "./TransactionCompleteDialog";
import { TransactionConfirmDialog } from "./TransactionConfirmDialog";
import { AddToCart } from "JS/Models/Media";

const Root = styled(Grid)(({ theme }) => ({
    backgroundColor: `${theme.palette.background.default}`,
}));

const BackIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.grey.A100,
    fontSize: "20px",
    marginRight: theme.spacing(2),
}));

const LeavePurchaseBtn = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey.A100,
}));

const Grey600Typography = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[600],
}));

const BackBtnContainer = styled("div")(() => ({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
}));

const PaymentMethodTxtContainer = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(2),
}));

export interface ContentPurchaseProps extends InternalStandardProps<GridProps> {
    backTitle: string;
    method: PaymentMethod;
    credits: number;
    requiredCredits?: string;
    totalPrice: string;
    onBackClick: () => void;
    onMethodChange: (method: PaymentMethod) => void;
    buying: boolean;
    activeGiftItem?: {
        title: string;
        giftPurchasedEnabled: boolean;
        quantity: number;
        giftPurchasedSuccess: boolean;
    };
    dialogs: {
        transactionComplete: boolean;
        transactionConfirmation: boolean;
        selectMembers: boolean;
    };
    setDialogs: (dialog: {
        transactionComplete: boolean;
        transactionConfirmation: boolean;
        selectMembers: boolean;
    }) => void;
    onBuy?: () => void;
    onBuyGift?: () => void;
    onSendContent?: () => void;
    onCloseConfirmDialog?: () => void;
    isRedemeableByToken: boolean;
    availableCreditsLoading?: boolean;
    cart?: AddToCart;
    selectedMembers?: any[];
    quantityLoading?: boolean;
    contentPrice: number;
    isPurchasingFailed?: boolean;
}

export const ContentPurchase = (props: ContentPurchaseProps) => {
    const {
        className,
        backTitle,
        method,
        credits,
        requiredCredits,
        totalPrice,
        contentPrice,
        onMethodChange,
        onBackClick,
        dialogs,
        buying,
        setDialogs,
        onBuy,
        onBuyGift,
        isRedemeableByToken,
        activeGiftItem,
        onSendContent,
        cart,
        selectedMembers,
        onCloseConfirmDialog,
        availableCreditsLoading,
        quantityLoading,
        isPurchasingFailed,
        ...rest
    } = props;
    return (
        <Root container {...rest} className={className}>
            {!isPurchasingFailed && (
                <TransactionCompleteDialog
                    open={dialogs.transactionComplete}
                    activeGiftItem={activeGiftItem}
                    onSendContent={onSendContent}
                    selectedMembers={selectedMembers}
                    onClose={onCloseConfirmDialog}
                    quantityLoading={quantityLoading}
                />
            )}
            <TransactionConfirmDialog
                method={method}
                open={dialogs.transactionConfirmation}
                cart={cart}
                onClose={() => {
                    setDialogs({
                        ...dialogs,
                        transactionConfirmation: false,
                    });
                }}
                onBuy={onBuy}
                giftPurchasedEnabled={activeGiftItem?.giftPurchasedEnabled}
                onBuyGift={onBuyGift}
                buying={buying}
            />
            <Grid item xs={12}>
                <BackBtnContainer onClick={onBackClick}>
                    <BackIcon icon={["fas", "chevron-left"]} />
                    <LeavePurchaseBtn variant="h5">
                        {backTitle}
                    </LeavePurchaseBtn>
                </BackBtnContainer>
            </Grid>

            <PaymentMethodTxtContainer item xs={12}>
                <Grey600Typography fontWeight={"bold"} variant="body1">
                    Payment Method
                </Grey600Typography>
            </PaymentMethodTxtContainer>
            <Grid item xs={12}>
                <PaymentMethodRadio
                    method={method}
                    onMethodChange={onMethodChange}
                    credits={credits}
                    availableCreditsLoading={availableCreditsLoading}
                    contentPrice={contentPrice}
                />
            </Grid>
        </Root>
    );
};
